const app = {
  http_url: "",
  file_url: "",
  timeout: 1000 * 300, //请求超时时间,
};
export default app;
